/* eslint-disable react/jsx-wrap-multilines */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import questions from '../../survey/questions';
import Switcher from '../../components/switcher';
import WeightRecommendations from '../../components/weightRecommendations';
import steps from '../../survey/steps';
import s from './index.module.scss';
import common from '../index.module.scss';
import InputStyle from './inputStyle/inputStyle';

function ValueAndUnits(props) {
	const { T } = useT();
	const {
		isThisCurrentStep, isCurrentStepCompleted, validationValues,
		questionName, inputId, stepName, showWeightRecommendations
	} = props;
	const currentStep = useSelector((state) => state.steps.currentStep);
	const config = useSelector(state => state.steps.config);
	const configTypeV1 = config === 'typeV1';

	const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
	const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';

	const savedQuestionValues = useSelector((state) => state.questions.savedAnswers[questionName]);
	const list = useSelector((state) => state.steps.list);

	const savedQuestionValuesValue = savedQuestionValues && savedQuestionValues.value && savedQuestionValues.value.value;
	const savedQuestionValuesUnits = savedQuestionValues && savedQuestionValues.units && savedQuestionValues.units.value;

	const [value, setValue] = useState(savedQuestionValuesValue || '');
	const [units, setUnits] = useState(savedQuestionValuesUnits || '');
	const [validationWarning, setValidation] = useState(false);

	const bottom = !props.singleWarning ? T(`${questionName}_warning_bottom`) : T(`${questionName}_warning`);
	const top = !props.singleWarning ? T(`${questionName}_warning_top`) : T(`${questionName}_warning`);

	const isWeight = currentStep === 'weight';
	const weightTitle = isWeight
		? questionName : configTypeV1
			? 'target_weight_typeV1'
			: 'target_weight';
	const weightDescription = isWeight
		? 'weight_description' : configTypeV1
			? 'target_weight_typeV1_description'
			: 'target_weight_description'
		;

	function validate() {
		if (units) {
			if (value !== '' && value < validationValues[units].bottom) {
				setValidation(bottom);
				return;
			}

			if (value !== '' && value > validationValues[units].top) {
				setValidation(top);
				return;
			}

			if (value !== '') {
				setValidation(true);
			}
		}
	}

	useEffect(() => {
		validate();
	}, [units, value, currentStep]);

	function onChangeAction(e) {
		setValue(e.target.value);

		questions.setAnswer({
			questionName,
			answerName: 'value',
			answerValue: {
				value: e.target.value
			}
		});
	}

	useEffect(() => {
		const completed = (value !== '' && units !== '' && validationWarning === true);

		steps.setStepStatus({
			stepName,
			stepStatus: completed
		});
	}, [units, value, list, currentStep, validationWarning]);

	function getCurrentUnitsValue() {
		return questions.getAnswers({ questionName }).units && questions.getAnswers({ questionName }).units.value || props.defaultUnits;
	}

	function changeUnits(unitsValue) {
		setUnits(unitsValue);

		questions.setAnswer({
			questionName,
			answerName: 'units',
			answerValue: {
				value: unitsValue
			}
		});
	}

	function onSwitcherChange(unitsValue) {
		changeUnits(unitsValue);
		questions.preventUnitsChanges({ name: stepName });
		document.querySelector(`#${currentStep}`).focus();
	}

	useEffect(() => {
		setUnits(getCurrentUnitsValue());
		changeUnits(getCurrentUnitsValue());
	}, []);

	useEffect(() => {
		setUnits(getCurrentUnitsValue());
		changeUnits(getCurrentUnitsValue());
	}, [currentStep]);

	function actionOnFocus() {
		setTimeout(() => {
			document.documentElement.scrollTop = -300;
		}, 50);
	}

	function weightRecommendations() {
		const weight = questions.getAnswers({ questionName: 'weight' });
		const height = questions.getAnswers({ questionName: 'height' });
		const userWeightValue = weight.units.value === 'kg' ? weight.value.value : weight.value.value * 0.453592;
		const userHeightValue = height.units.value === 'cm' ? height.value.value : height.value.value * 2.54;
		const bmiProgress = (userWeightValue / (((userHeightValue / 100) * (userHeightValue / 100)))).toFixed(2);

		if (bmiProgress > 18.5 && bmiProgress < 25) return '';

		return <WeightRecommendations />;
	}

	return (
		<div className={`${common.step} ${s.step} ${isThisCurrentStepClass} ${isThisStepCompletedClass}`}>
			<div className={common.stepTitle}>{T(weightTitle)}</div>
			<div className={common.stepDescription}>{T(weightDescription)}</div>

			<Switcher
				className={s.switcher}
				value1={props.units[0]}
				value2={props.units[1]}
				currentValue={getCurrentUnitsValue()}
				actionOnChange={onSwitcherChange}
				disableFromFocus={!isThisCurrentStep}
			/>
			<InputStyle
				onChangeAction={onChangeAction}
				isThisCurrentStep={isThisCurrentStep}
				actionOnFocus={actionOnFocus}
				inputId={inputId}
				value={value}
				inputStyle={props.inputStyle}
			/>
			{
				validationWarning &&
				(
					<div className={s.warning}>
						{validationWarning}
					</div>
				)
			}
			{showWeightRecommendations && !configTypeV1 && weightRecommendations()}
		</div>
	);
}

export default ValueAndUnits;
